import { BNPL_LIGHT_ALT_GLOBAL_STYLES } from '../../designSystem/reloaded/bnplLightAlt/baseStyles';
import { BNPL_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/bnplLightAlt/styles';
import { BNPL_LIGHT_REGULAR_GLOBAL_STYLES } from '../../designSystem/reloaded/bnplLightRegular/baseStyles';
import { BNPL_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/bnplLightRegular/styles';
import { COBRANDED_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/cobrandedLightAlt/styles';
import { COBRANDED_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/cobrandedLightRegular/styles';
import { FONTS_RELOADED_COBRANDED_GLOBAL_STYLES } from '../../designSystem/reloaded/config/cobranded/globalStyles/fonts';
import { RELOADED_COBRANDED_GLOBAL_STYLES } from '../../designSystem/reloaded/config/cobranded/globalStyles/globalStyles';
import { FONTS_RELOADED_FLAME_GLOBAL_STYLES } from '../../designSystem/reloaded/config/flame/globalStyles/fonts';
import { FONTS_RELOADED_HORIZON_GLOBAL_STYLES } from '../../designSystem/reloaded/config/horizon/globalStyles/fonts';
import { FONTS_RELOADED_MODELBANK_GLOBAL_STYLES } from '../../designSystem/reloaded/config/modelbank/globalStyles/fonts';
import { FONTS_RELOADED_NOVA_GLOBAL_STYLES } from '../../designSystem/reloaded/config/nova/globalStyles/fonts';
import { FONTS_RELOADED_ZINIA_GLOBAL_STYLES } from '../../designSystem/reloaded/config/zinia/globalStyles/fonts';
import { FLAME_PRIVATE_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flamePrivateLightAlt/baseStyles';
import { FLAME_PRIVATE_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/flamePrivateLightAlt/styles';
import { FLAME_PRIVATE_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flamePrivateLightInverse/baseStyles';
import { FLAME_PRIVATE_LIGHT_INVERSE_STYLES } from '../../designSystem/reloaded/flamePrivateLightInverse/styles';
import { FLAME_PRIVATE_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flamePrivateLightRegular/baseStyles';
import { FLAME_PRIVATE_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/flamePrivateLightRegular/styles';
import { FLAME_RETAIL_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameRetailLightAlt/baseStyles';
import { FLAME_RETAIL_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/flameRetailLightAlt/styles';
import { FLAME_RETAIL_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameRetailLightInverse/baseStyles';
import { FLAME_RETAIL_LIGHT_INVERSE_STYLES } from '../../designSystem/reloaded/flameRetailLightInverse/styles';
import { FLAME_RETAIL_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameRetailLightRegular/baseStyles';
import { FLAME_RETAIL_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/flameRetailLightRegular/styles';
import { FLAME_RETAIL_LIGHT_WEALTH_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameRetailLightWealthAlt/baseStyles';
import { FLAME_RETAIL_LIGHT_WEALTH_ALT_STYLES } from '../../designSystem/reloaded/flameRetailLightWealthAlt/styles';
import { FLAME_RETAIL_LIGHT_WEALTH_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameRetailLightWealthRegular/baseStyles';
import { FLAME_RETAIL_LIGHT_WEALTH_REGULAR_STYLES } from '../../designSystem/reloaded/flameRetailLightWealthRegular/styles';
import { FLAME_SELECT_LIGHT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameSelectLightAlt/baseStyles';
import { FLAME_SELECT_LIGHT_STYLES } from '../../designSystem/reloaded/flameSelectLightAlt/styles';
import { FLAME_SELECT_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameSelectLightInverse/baseStyles';
import { FLAME_SELECT_LIGHT_INVERSE_STYLES } from '../../designSystem/reloaded/flameSelectLightInverse/styles';
import { FLAME_SELECT_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/flameSelectLightRegular/baseStyles';
import { FLAME_SELECT_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/flameSelectLightRegular/styles';
import { HORIZON_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/horizonLightAlt/baseStyles';
import { HORIZON_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/horizonLightAlt/styles';
import { HORIZON_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/horizonLightInverse/baseStyles';
import { HORIZON_LIGHT_INVERSE_STYLES } from '../../designSystem/reloaded/horizonLightInverse/styles';
import { HORIZON_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/horizonLightRegular/baseStyles';
import { HORIZON_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/horizonLightRegular/styles';
import { MODELBANK_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/modelBankLightAlt/baseStyles';
import { MODEL_BANK_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/modelBankLightAlt/styles';
import { MODELBANK_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/modelBankLightRegular/baseStyles';
import { MODEL_BANK_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/modelBankLightRegular/styles';
import { NOVA_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/novaLightAlt/baseStyles';
import { NOVA_LIGHT_ALT_STYLES } from '../../designSystem/reloaded/novaLightAlt/styles';
import { NOVA_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER } from '../../designSystem/reloaded/novaLightRegular/baseStyles';
import { NOVA_LIGHT_REGULAR_STYLES } from '../../designSystem/reloaded/novaLightRegular/styles';
import { genericComponents } from './../genericComponents/genericComponents';
import { reloadedThemes } from './types/reloadedProvider';
// eslint-disable-next-line complexity
export const getThemeConfig = (theme, elementContainer) => {
    switch (theme) {
        case reloadedThemes.reloaded_horizon_light:
            return {
                customFonts: FONTS_RELOADED_HORIZON_GLOBAL_STYLES,
                customGlobalStyles: HORIZON_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: HORIZON_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'HORIZON_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.reloaded_horizon_alternative:
            return {
                customFonts: FONTS_RELOADED_HORIZON_GLOBAL_STYLES,
                customGlobalStyles: HORIZON_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: HORIZON_LIGHT_ALT_STYLES,
                themeInformation: { name: 'HORIZON_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.reloaded_nova_light:
            return {
                customFonts: FONTS_RELOADED_NOVA_GLOBAL_STYLES,
                customGlobalStyles: NOVA_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: NOVA_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'NOVA_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.reloaded_nova_alternative:
            return {
                customFonts: FONTS_RELOADED_NOVA_GLOBAL_STYLES,
                customGlobalStyles: NOVA_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: NOVA_LIGHT_ALT_STYLES,
                themeInformation: { name: 'NOVA_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.reloaded_modelbank_light:
            return {
                customFonts: FONTS_RELOADED_MODELBANK_GLOBAL_STYLES,
                customGlobalStyles: MODELBANK_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: MODEL_BANK_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'MODEL_BANK_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.reloaded_modelbank_alternative:
            return {
                customFonts: FONTS_RELOADED_MODELBANK_GLOBAL_STYLES,
                customGlobalStyles: MODELBANK_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: MODEL_BANK_LIGHT_ALT_STYLES,
                themeInformation: { name: 'MODEL_BANK_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_private_light_alt:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_PRIVATE_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_PRIVATE_LIGHT_ALT_STYLES,
                themeInformation: { name: 'FLAME_PRIVATE_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_private_light_regular:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_PRIVATE_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_PRIVATE_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'FLAME_PRIVATE_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_alt:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_ALT_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_regular:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_select_light_alt:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_SELECT_LIGHT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_SELECT_LIGHT_STYLES,
                themeInformation: { name: 'FLAME_SELECT_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_select_light_regular:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_SELECT_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_SELECT_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'FLAME_SELECT_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_wealth_alt:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_WEALTH_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_WEALTH_ALT_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_WEALTH_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_wealth_regular:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_WEALTH_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_WEALTH_REGULAR_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_WEALTH_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.horizon_light_regular:
            return {
                customFonts: FONTS_RELOADED_HORIZON_GLOBAL_STYLES,
                customGlobalStyles: HORIZON_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: HORIZON_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'HORIZON_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.horizon_light_alternative:
            return {
                customFonts: FONTS_RELOADED_HORIZON_GLOBAL_STYLES,
                customGlobalStyles: HORIZON_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: HORIZON_LIGHT_ALT_STYLES,
                themeInformation: { name: 'HORIZON_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.horizon_light_inverse:
            return {
                customFonts: FONTS_RELOADED_HORIZON_GLOBAL_STYLES,
                customGlobalStyles: HORIZON_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: HORIZON_LIGHT_INVERSE_STYLES,
                themeInformation: { name: 'HORIZON_LIGHT_INVERSE' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.nova_light_regular:
            return {
                customFonts: FONTS_RELOADED_NOVA_GLOBAL_STYLES,
                customGlobalStyles: NOVA_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: NOVA_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'NOVA_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.nova_light_alternative:
            return {
                customFonts: FONTS_RELOADED_NOVA_GLOBAL_STYLES,
                customGlobalStyles: NOVA_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: NOVA_LIGHT_ALT_STYLES,
                themeInformation: { name: 'NOVA_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.modelbank_light_regular:
            return {
                customFonts: FONTS_RELOADED_MODELBANK_GLOBAL_STYLES,
                customGlobalStyles: MODELBANK_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: MODEL_BANK_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'MODEL_BANK_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.modelbank_light_alternative:
            return {
                customFonts: FONTS_RELOADED_MODELBANK_GLOBAL_STYLES,
                customGlobalStyles: MODELBANK_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: MODEL_BANK_LIGHT_ALT_STYLES,
                themeInformation: { name: 'MODEL_BANK_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_private_light_alternative:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_PRIVATE_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_PRIVATE_LIGHT_ALT_STYLES,
                themeInformation: { name: 'FLAME_PRIVATE_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_private_light_inverse:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_PRIVATE_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_PRIVATE_LIGHT_INVERSE_STYLES,
                themeInformation: { name: 'FLAME_PRIVATE_LIGHT_INVERSE' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_alternative:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_ALT_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_inverse:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_INVERSE_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_INVERSE' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_select_light_alternative:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_SELECT_LIGHT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_SELECT_LIGHT_STYLES,
                themeInformation: { name: 'FLAME_SELECT_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_select_light_inverse:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_SELECT_LIGHT_INVERSE_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_SELECT_LIGHT_INVERSE_STYLES,
                themeInformation: { name: 'FLAME_SELECT_LIGHT_INVERSE' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.flame_retail_light_wealth_alternative:
            return {
                customFonts: FONTS_RELOADED_FLAME_GLOBAL_STYLES,
                customGlobalStyles: FLAME_RETAIL_LIGHT_WEALTH_ALT_GLOBAL_STYLES_ELEMENT_CONTAINER(elementContainer),
                styles: FLAME_RETAIL_LIGHT_WEALTH_ALT_STYLES,
                themeInformation: { name: 'FLAME_RETAIL_LIGHT_WEALTH_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.cobranded_light_alternative:
            return {
                customFonts: FONTS_RELOADED_COBRANDED_GLOBAL_STYLES,
                customGlobalStyles: RELOADED_COBRANDED_GLOBAL_STYLES,
                styles: COBRANDED_LIGHT_ALT_STYLES,
                themeInformation: { name: 'COBRANDED_LIGHT_ALT' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.cobranded_light_regular:
            return {
                customFonts: FONTS_RELOADED_COBRANDED_GLOBAL_STYLES,
                customGlobalStyles: RELOADED_COBRANDED_GLOBAL_STYLES,
                styles: COBRANDED_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'COBRANDED_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.bnpl_light_alternative:
            return {
                customFonts: FONTS_RELOADED_ZINIA_GLOBAL_STYLES,
                customGlobalStyles: BNPL_LIGHT_ALT_GLOBAL_STYLES,
                styles: BNPL_LIGHT_ALT_STYLES,
                themeInformation: { name: 'BNPL_LIGHT_ALTERNATIVE' },
                genericComponents: genericComponents,
            };
        case reloadedThemes.bnpl_light_regular:
            return {
                customFonts: FONTS_RELOADED_ZINIA_GLOBAL_STYLES,
                customGlobalStyles: BNPL_LIGHT_REGULAR_GLOBAL_STYLES,
                styles: BNPL_LIGHT_REGULAR_STYLES,
                themeInformation: { name: 'BNPL_LIGHT_REGULAR' },
                genericComponents: genericComponents,
            };
    }
};
//# sourceMappingURL=config.js.map